const PRIMARY = '#0E0C4D'
const PRIMARY_LIGHT = '#193069'
const SECONDARY = '#DD9557'
const SECONDARY_LIGHT = '#C57129'
const DARK_RED = '#DA2C38'
const DARK_BLUE = '#081A49'
const WHITE = '#FFFFFF'
const COLOR_ERROR = '#FF3D3D'
const COLOR_ALERT = '#333333'
const COLOR_INFO = '#2296F3'
const COLOR_SUCCESS = '#4CAF50'
const COLOR_WARNING = '#FF9800'
//m5 Colors
const MAIN_BG_COLOR = '#F6F7FB'
const VIP_BG_COLOR = '#121212'
const COLOR_1B1B1B = '#1B1B1B'
const COLOR_YELLOW = '#FFE800'
const COLOR_ORANGE_FF8A00 = '#FF8A00'
const COLOR_BLACK_333333 = '#333333'
const COLOR_BLACK_666666 = '#666666'
const COLOR_BLACK_959595 = '#959595'
const COLOR_BLACK_D3D3D3 = '#D3D3D3'
const COLOR_BLACK_191919 = '#191919'
const COLOR_BLACK = '#000000'
const COLOR_DDE1ED = '#DDE1ED'
const COLOR_DAD3ED = '#DAD3ED'
const COLOR_BFB1DC = '#bfb1dc'
const COLOR_WHITE = '#FFFFFF'
const COLOR_BACKGROUND = '#F6F7FB'
const COLOR_GREY_F6F7FB = '#F6F7FB'
const COLOR_GREY_D4D9E8 = '#D4D9E8'
const COLOR_GREY_E2E6F5 = '#E2E6F5'
const COLOR_GREY_EDF0FA = '#EDF0FA'
const COLOR_121212 = '#121212'
const COLOR_GREY_C6C6C6 = '#C6C6C6'
const COLOR_GREY_F2F4F5 = '#F2F4F5'
const COLOR_GREY_9D9D9D = '#9D9D9D'
const COLOR_GREY_EBE7F6 = '#EBE7F6'
const COLOR_GREY_D0D0D0 = '#D0D0D0'
const COLOR_SHADOW = '#E1E6F5'
const COLOR_141414 = '#141414'
const COLOR_PURPLE = '#4611A7'
const COLOR_595959 = '#595959'
const COLOR_4F4F4F = '#4F4F4F'
const COLOR_GREEN = '#50DC6E'
const COLOR_PINK = '#FF8D96'
const COLOR_PINK_FF39A4 = '#FF39A4'
const DARK_MODE_COLOR = '#121212'
const DARK_BLUE_COLOR = '#10255B'
const COLOR_RED_FF3D3D = '#FF3D3D'
const BASE_BG_COLOR = '#E5E5E5'
const COLOR_GREY_999999 = '#999999'
const COLOR_1DAE34 = '#1DAE34'
const COLOR_CCCCCC = '#CCCCCC'
const COLOR_999999 = '#999999'
const COLOR_58668C = '#58668C'
const COLOR_D95C6A = '#D95C6A'
const COLOR_RED = '#FF0000'
const COLOR_8E8E8E = '#8E8E8E'
const VIOLET_A2238E = '#A2238E'
const COLOR_F2F4F5 = '#F2F4F5'
const COLOR_E28902 = '#E28902'
const COLOR_FF3D3D = '#FF3D3D'
const COLOR_RED_FF9F9F = '#FF9F9F'
const COLOR_GREY_E2E2E2 = '#E2E2E2'
const COLOR_BLUE = 'rgb(19,24,188)'
const COLOR_BLUE_HOME = 'rgb(8,25,144)'
const COLOR_BLUE_COUPON = '#EAE7F5'
const COLOR_ERROR_FADEDE = '#FADEDE'
const COLOR_BLUE_0A1C58 = '#0A1C58'
const COLOR_GREEN_50DC6E = '#50DC6E'
const COLOR_GREEN_DFFFE4 = '#DFFFE4'
const COLOR_GREEN_0A5C17 = '#0A5C17'
const COLOR_HEX_66000000 = '#66000000'
const COLOR_GREEN_33ED11 = '#33ED11'
const COLOR_GREEN_E4F5E7 = '#e4f5e7'
const COLOR_GREEN_3EBA52 = '#3eba52'
const COLOR_PEACH_FFE6B0 = '#FFE6B0'
const COLOR_PEACH_FFF4AB = '#FFF4AB'
const COLOR_BLUE_06174C = '#06174C'
const COLOR_BLUE_1B46B6 = '#1B46B6'
const COLOR_BLACK_0F255E = '#0F255E'
const COLOR_RED_B51F3F = '#B51F3F'
const COLOR_RED_EF4F41 = '#EF4F41'
const COLOR_RED_FFEFEF = '#FFEFEF'
const COLOR_ORANGE_C8690D = '#C8690D'
const COLOR_ORANGE_E47B15 = '#E47B15'
const COLOR_ORANGE_FF792E = '#FF792E'
const COLOR_ORANGE_FFEDD4 = '#FFEDD4'
const COLOR_YELLOW_FFD02A = '#FFD02A'
const COLOR_BLUE_809AE7 = '#809AE7'
const COLOR_YELLOW_FFC66E = '#FFC66E'
const COLOR_YELLOW_F2EDC5 = '#F2EDC5'
const COLOR_GREY_A5B0DE = '#A5B0DE'
const COLOR_50DC6E = '#50DC6E'
const COLOR_0E8C22 = '#0E8C22'
const COLOR_EBE7F6 = '#EBE7F6'
const COLOR_F0DC32 = '#F0DC32'
const COLOR_282727 = '#282727'
const COLOR_BROWN_6B4000 = '#6B4000'
const COLOR_4AF32F = '#4AF32F'
const COLOR_F64161 = '#F64161'
const COLOR_0A0E19 = '#0A0E19'
const COLOR_2D344B = '#2D344B'
const COLOR_1D2A3C = '#1D2A3C'
const COLOR_3E3A3A = '#3E3A3A'
const COLOR_BLUE_3B6CF4 = '#3B6CF4'
const COLOR_E2F6FB = '#E2F6FB'
const COLOR_0097ED = '#0097ED'
const COLOR_FAFAFA = '#FAFAFA'
const COLOR_D2EAFF = '#D2EAFF'
const COLOR_9BD1E8 = '#9BD1E8'
const COLOR_B4D1FF = '#B4D1FF'
const COLOR_D7F3FF = '#D7F3FF'
const COLOR_FFECC9 = '#FFECC9'
const COLOR_CFEEFF = '#CFEEFF'
const COLOR_FFC0C0 = '#FFC0C0'
const COLOR_B5FFD4 = '#B5FFD4'
const COLOR_292D31 = '#292D31'
const COLOR_EDC845 = '#EDC845'
const COLOR_FFE059 = '#FFE059'
const COLOR_F5CC44 = '#F5CC44'
const COLOR_FFC751 = '#FFC751'
const COLOR_B8ABDB = '#B8ABDB'
const COLOR_797D8D = '#797D8D'
const COLOR_F5FEFF = '#F5FEFF'
const COLOR_11225E = '#11225E'
const COLOR_0091FF = '#0091FF'
const COLOR_6F1919 = '#6F1919'

// Hex colors
const COLOR_HEX_50DC6E00 = '#50DC6E00'
const COLOR_80EDF0FA = '#EDF0FA'

export {
  WHITE,
  PRIMARY,
  COLOR_4F4F4F,
  DARK_RED,
  DARK_BLUE,
  COLOR_BFB1DC,
  COLOR_F2F4F5,
  COLOR_595959,
  SECONDARY,
  COLOR_1DAE34,
  COLOR_PINK,
  COLOR_INFO,
  COLOR_GREEN,
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_ERROR,
  COLOR_ALERT,
  COLOR_PURPLE,
  COLOR_SHADOW,
  COLOR_YELLOW,
  COLOR_ORANGE_FF8A00,
  BASE_BG_COLOR,
  PRIMARY_LIGHT,
  MAIN_BG_COLOR,
  COLOR_SUCCESS,
  COLOR_WARNING,
  SECONDARY_LIGHT,
  COLOR_BACKGROUND,
  COLOR_GREY_E2E6F5,
  COLOR_GREY_EDF0FA,
  COLOR_GREY_C6C6C6,
  COLOR_GREY_D4D9E8,
  COLOR_GREY_F2F4F5,
  COLOR_GREY_9D9D9D,
  COLOR_BLACK_333333,
  COLOR_BLACK_666666,
  COLOR_BLACK_959595,
  COLOR_BLACK_D3D3D3,
  DARK_MODE_COLOR,
  DARK_BLUE_COLOR,
  COLOR_BLACK_191919,
  COLOR_RED_FF3D3D,
  COLOR_CCCCCC,
  COLOR_999999,
  COLOR_58668C,
  COLOR_DDE1ED,
  COLOR_DAD3ED,
  COLOR_D95C6A,
  COLOR_121212,
  COLOR_GREY_999999,
  COLOR_RED,
  COLOR_8E8E8E,
  VIOLET_A2238E,
  COLOR_E28902,
  COLOR_FF3D3D,
  COLOR_GREY_E2E2E2,
  COLOR_BLUE,
  COLOR_BLUE_COUPON,
  COLOR_ERROR_FADEDE,
  COLOR_BLUE_0A1C58,
  COLOR_GREEN_50DC6E,
  COLOR_GREEN_DFFFE4,
  COLOR_GREEN_0A5C17,
  COLOR_BLUE_HOME,
  COLOR_HEX_66000000,
  COLOR_GREEN_33ED11,
  COLOR_PEACH_FFE6B0,
  COLOR_PEACH_FFF4AB,
  COLOR_BLUE_06174C,
  COLOR_BLUE_1B46B6,
  COLOR_BLACK_0F255E,
  COLOR_RED_B51F3F,
  COLOR_ORANGE_C8690D,
  COLOR_ORANGE_E47B15,
  COLOR_YELLOW_FFD02A,
  COLOR_BLUE_809AE7,
  COLOR_RED_EF4F41,
  COLOR_1B1B1B,
  COLOR_YELLOW_FFC66E,
  COLOR_YELLOW_F2EDC5,
  COLOR_GREY_A5B0DE,
  COLOR_50DC6E,
  COLOR_HEX_50DC6E00,
  COLOR_0E8C22,
  COLOR_EBE7F6,
  COLOR_141414,
  COLOR_ORANGE_FFEDD4,
  COLOR_BROWN_6B4000,
  COLOR_RED_FFEFEF,
  COLOR_ORANGE_FF792E,
  COLOR_PINK_FF39A4,
  COLOR_RED_FF9F9F,
  COLOR_GREEN_E4F5E7,
  COLOR_GREEN_3EBA52,
  COLOR_GREY_EBE7F6,
  COLOR_GREY_F6F7FB,
  COLOR_GREY_D0D0D0,
  COLOR_F0DC32,
  COLOR_282727,
  VIP_BG_COLOR,
  COLOR_4AF32F,
  COLOR_F64161,
  COLOR_0A0E19,
  COLOR_2D344B,
  COLOR_BLUE_3B6CF4,
  COLOR_3E3A3A,
  COLOR_1D2A3C,
  COLOR_E2F6FB,
  COLOR_0097ED,
  COLOR_FAFAFA,
  COLOR_D2EAFF,
  COLOR_9BD1E8,
  COLOR_B4D1FF,
  COLOR_D7F3FF,
  COLOR_FFECC9,
  COLOR_CFEEFF,
  COLOR_FFC0C0,
  COLOR_B5FFD4,
  COLOR_292D31,
  COLOR_EDC845,
  COLOR_FFE059,
  COLOR_F5CC44,
  COLOR_FFC751,
  COLOR_B8ABDB,
  COLOR_797D8D,
  COLOR_F5FEFF,
  COLOR_11225E,
  COLOR_0091FF,
  COLOR_6F1919,
  COLOR_80EDF0FA
}
